document.addEventListener("DOMContentLoaded",event=>{
  // initFixedAddCard();
});

function initFixedAddCard(){
  if(productJson['id'] == 7903769002226 || productJson['id'] == 8633990775129)return;
  console.log("initFixedAddCard");
  let bootom_height = 0;
  console.log("bootom_height:"+bootom_height);
  let add_cart_html = `<div class="fixed_add_cart" style="
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0px;
    padding: 15px 0;
    z-index: 1 !important;
    display:none;
"><button style="
    display: block;
    width: 92%;
    padding: 15px 0;
    background: #B3BE93;
    color: #14141C;
    z-index:999;
    font-weight:800;
    border: 1px solid #3D3E38;
    border-radius: 50px;
    font-size: 13px;
    margin: 0 auto;
">ADD TO CART</button></div>`;


  
  if(window.innerWidth <= 750){
    $("main#MainContent").after(add_cart_html);
    let is_disabled = 0;
    var cart_html_index = setInterval(function(){
      if($("#product-form-template--19322627621209__main button[type='submit']")){
        if($("#product-form-template--19322627621209__main button[type='submit']").prop("disabled")){
          is_disabled = 1;
        }
        console.log("is_disabled:"+is_disabled);
        if(is_disabled){
         $(".fixed_add_cart button").prop("disabled",true);
         $(".fixed_add_cart button").css("background","#7F7F7F");
          $(".fixed_add_cart button").css("color","#FFF");
         $(".fixed_add_cart button").text($("#product-form-template--19322627621209__main button[type='submit'] span").text().toLocaleUpperCase());
        }
        clearInterval(cart_html_index);
        return;
      }
    },1000);
   
    $(".fixed_add_cart").click(function(){
      // layer.msg('add to carting...');
      document.querySelector("div.product-form__buttons button.product-form__submit[type='submit']").click();
      //监控购物车内容显示
      setTimeout(function(){
        console.log("display:"+$(".product-form__error-message-wrapper").css('display'));
        if($(".product-form__error-message-wrapper").css('display') != "none"){
         $("html,body").scrollTop($(".product-form__error-message-wrapper").offset().top-200);
        }
        },500);
    });

    let showTop = $(".about-product").offset().top;
    $(window).scroll(function(event){
	  var toTop = $(window).scrollTop();
      if(toTop >= showTop){
        $(".fixed_add_cart").show();
      }else{
        $(".fixed_add_cart").hide();
      }
    });
  }
}